module.exports = __webpack_public_path__ + "static/img/quick_link02.26aa6115.png";